import React from "react";
import { FaArrowRight } from "react-icons/fa"; // import arrow icon

const DownloadAppTwo = () => {
  return (
    <section className="download-app-two section-space">

      {/* Background */}
      <div
        className="download-app-two__bg"
        style={{
          backgroundImage:
            "url(assets/images/shapes/download-app-bg-2-1.jpg)",
        }}
      ></div>

      <div className="container">

        {/* Section Title */}
        <div className="sec-title sec-title--center">
          <div className="sec-title__top">
            <div className="sec-title__shape"></div>
            <h6 className="sec-title__tagline">Travel With Lotus Cab</h6>
            <div className="sec-title__shape"></div>
          </div>

          <h3 className="sec-title__title">Experience Seamless Rides</h3>
        </div>

        <div className="row gutter-y-40 align-items-center">

          {/* Left Column */}
          <div className="col-lg-4">
            <div className="download-app-two__left">

              <div className="download-app-two__item" style={{ display: "flex", alignItems: "flex-start" }}>
                <div className="download-app-two__item__icon" style={{ marginRight: 10, color: "#000", fontSize: "20px", marginTop: "5px" }}>
                  <FaArrowRight />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Wide Range Of Vehicles
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    From economy rides to luxury cars, Lotus Cab offers a variety of vehicles to suit every journey and budget.
                  </p>
                </div>
              </div>

              <div className="download-app-two__item" style={{ display: "flex", alignItems: "flex-start" }}>
                <div className="download-app-two__item__icon" style={{ marginRight: 10, color: "#000", fontSize: "20px", marginTop: "5px" }}>
                  <FaArrowRight />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Experienced & Professional Drivers
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    Our drivers are background-checked, well-trained, and committed to providing you with a safe and courteous ride.
                  </p>
                </div>
              </div>

            </div>
          </div>

          {/* Center Image */}
          <div className="col-lg-4">
            <div className="download-app-two__image">
              <div
                className="download-app-two__image__inner"
                style={{
                  backgroundImage:
                    "url(assets/images/resources/download-app-2-1.jpg)",
                }}
              ></div>

              <img
                src="/images/about.png"
                alt="Lotus Cab Vehicle Mockup"
                className="download-app-two__image__mockup"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-4">
            <div className="download-app-two__right">

              <div className="download-app-two__item" style={{ display: "flex", alignItems: "flex-start" }}>
                <div className="download-app-two__item__icon" style={{ marginRight: 10, color: "#000", fontSize: "20px", marginTop: "5px" }}>
                  <FaArrowRight />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Instant Booking & Emergency Rides
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    With real-time tracking and quick pickup options, Lotus Cab ensures you're never left waiting — day or night.
                  </p>
                </div>
              </div>

              <div className="download-app-two__item" style={{ display: "flex", alignItems: "flex-start" }}>
                <div className="download-app-two__item__icon" style={{ marginRight: 10, color: "#000", fontSize: "20px", marginTop: "5px" }}>
                  <FaArrowRight />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Affordable & Transparent Pricing
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    No hidden fees, no surprises. Just fair, upfront rates that work for every passenger.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      {/* Decorative Shape */}
      <img
        src="assets/images/shapes/download-app-shape-2-1.png"
        alt="shape"
        className="download-app-two__shape"
      />

    </section>
  );
};

export default DownloadAppTwo;
